import React from 'react';
import ThemeProvider from '../context/ThemeProvider';
export default function withThemeProvider(Component, themeID) {
    const WithThemeProvider = ({ ...props }) => {
        return (React.createElement(ThemeProvider, { theme: themeID },
            React.createElement(Component, { ...props })));
    };
    return WithThemeProvider;
}
